import React from 'react';
//import {authRoles} from '../../auth';

export const UserCargosUpdateConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    auth: ['master', 'rh', 'rh_not_signer'],
    routes: [{
        path: '/user-cargos-details/:id',
        component: React.lazy(() =>
            import ('./UserCargosUpdate'))
    }]
};